export function enableLogBuffer(): void {
  return;
}
